import * as types from "./actionTypes";

export const modalData = data => {
  return {
    type: types.DOWNLOAD_FILE_MODAL_DATA,
    data
  };
};
export const closeModal = () => {
  return {
    type: types.DOWNLOAD_FILE_CLOSE_MODAL
  };
};

export const reportRequest = data => {
  return {
    type: types.DOWNLOAD_FILE_REPORT_REQUEST,
    data
  };
};
export const reportSuccess = data => {
  return {
    type: types.DOWNLOAD_FILE_REPORT_SUCCESS,
    payLoad: data
  };
};
export const reportFailure = () => {
  return {
    type: types.DOWNLOAD_FILE_REPORT_FAILURE
  };
};
export const countToastToggle = () => {
  return {
    type: types.DOWNLOAD_FILE_COUNT_TOAST_TOGGLE
  };
};

export const checkFilesRequest = () => {
  return {
    type: types.DOWNLOAD_FILE_CHECK_FILES_REQUEST
  };
};
export const checkFilesSuccess = data => {
  return {
    type: types.DOWNLOAD_FILE_CHECK_FILES_SUCCESS,
    payLoad: data
  };
};
export const checkFilesFailure = () => {
  return {
    type: types.DOWNLOAD_FILE_CHECK_FILES_FAILURE
  };
};
export const toasted = id => {
  return {
    type: types.DOWNLOAD_FILE_TOASTED,
    payLoad: id
  };
};
